const CardSkeletons = ({ total }: { total: number }) => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3  gap-6'>
      {Array.from(Array(total), (_, i) => {
        return (
          <div className='bg-zinc-200 dark:bg-slate-600 rounded-md gap-4 px-4 py-6 flex w-full' key={i}>
            <div className='animate-pulse size-12 rounded-full bg-zinc-300 dark:bg-slate-700' />
            <div className='space-y-2 animate-pulse'>
              <div className='h-3 w-24 rounded-sm bg-zinc-300 dark:bg-slate-700' />
              <div className='h-3 w-20 rounded-sm bg-zinc-300 dark:bg-slate-700' />
              <div className='h-3 w-32 rounded-sm bg-zinc-300 dark:bg-slate-700' />
            </div>
            <div className='animate-pulse size-4 bg-zinc-300 dark:bg-slate-700 ml-auto rounded-sm' />
          </div>
        )
      })}
    </div>
  )
}

export default CardSkeletons
